import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';

import { defaultKSK2022_R01LotDto, defaultKSK2022_R01HeaderDto, defaultKSK2022_R01InspectDto, KSK2022_R01LotDto, KSK2022_R01HeaderDto, KSK2022_R01InspectDto, KSK2022_R01DetailDto, defaultKSK2022_R01DetailDto, KSK2022_R01WorkStandardDto } from './Dto_KSK2022_R01';
import { showWarning } from 'src/utils/toast/toastUtil';
import { getFutureWeekdayExceptTodayAndTomorrow } from 'src/utils/date/dateUtils';
import { WareHouseDto } from 'src/dtos/warehouse/wareHouseDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { calculateTotalOrderQty } from 'src/components/common/common';


export interface KSK2022_R01Filter {	
	labelPrintAuto: string;
}

export interface Store_KSK2022_R01 {
	KSK2022_R01Filter: KSK2022_R01Filter;
	KSK2022_R01PastFilter: KSK2022_R01Filter;
	setKSK2022_R01Filter: (filter: Partial<Store_KSK2022_R01['KSK2022_R01Filter']>) => void;
	setKSK2022_R01PastFilter: (filter: Store_KSK2022_R01['KSK2022_R01PastFilter']) => void;
	
	// ====== 생산실적 리스트 및 선택/편집 ======
	KSK2022_R01List: KSK2022_R01HeaderDto[];
	setKSK2022_R01List: (salesList: KSK2022_R01HeaderDto[]) => void;

	editKSK2022_R01: KSK2022_R01HeaderDto | null;
	setEditKSK2022_R01: (editHeader: KSK2022_R01HeaderDto | null) => void;

	// selectedKSK2022_R01: KSK2022_R01HeaderDto | undefined;
	// setSelectedKSK2022_R01: (data: KSK2022_R01HeaderDto | undefined) => void;
	// initSelectedKSK2022_R01: () => void;

	// ====== 생산실적 상세(lot) 데이터 ======
	KSK2022_R01LotList: KSK2022_R01LotDto[];
	setKSK2022_R01LotList: (data: KSK2022_R01LotDto[]) => void;
	insertKSK2022_R01LotList: (data: KSK2022_R01LotDto[], index?: number) => void;
	removeKSK2022_R01LotList: (index: number) => void;
	updateKSK2022_R01LotList: (index: number, data: KSK2022_R01LotDto) => void;

	// ====== 선택(lot) 행 선택/삭제 관리 ======
	selectedKSK2022_R01LotList: string[];
	setSelectedKSK2022_R01LotList: (idList: string[]) => void;
	addSelectedKSK2022_R01LotList: (idList: string[]) => void;
	removeSelectedKSK2022_R01LotList: (idList?: string[]) => void;
	initSelectedKSK2022_R01LotList: () => void;

	// ====== 상세(lot) 행 선택/삭제 관리 ======
	deletedKSK2022_R01LotList: string[];
	setDeletedKSK2022_R01LotList: (idList: string[]) => void;
	addDeletedKSK2022_R01LotList: (idList: string[]) => void;
	removeDeletedKSK2022_R01LotList: (idList?: string[]) => void;

	originalKSK2022_R01LotList: KSK2022_R01LotDto[];
	setOriginalKSK2022_R01LotList: (data: KSK2022_R01LotDto[]) => void;

	// ====== 자재출고 상세(디테일) 데이터 ======
	KSK2022_R01DetailList: KSK2022_R01DetailDto[];
	setKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[]) => void;
	insertKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[], index?: number) => void;
	removeKSK2022_R01DetailList: (index: number) => void;
	updateKSK2022_R01DetailList: (index: number, data: KSK2022_R01DetailDto) => void;

	// ====== 선택(디테일) 행 선택/삭제 관리 ======
	selectedKSK2022_R01DetailList: string[];
	setSelectedKSK2022_R01DetailList: (idList: string[]) => void;
	addSelectedKSK2022_R01DetailList: (idList: string[]) => void;
	removeSelectedKSK2022_R01DetailList: (idList?: string[]) => void;
	initSelectedKSK2022_R01DetailList: () => void;

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2022_R01DetailList: string[];
	setDeletedKSK2022_R01DetailList: (idList: string[]) => void;
	addDeletedKSK2022_R01DetailList: (idList: string[]) => void;
	removeDeletedKSK2022_R01DetailList: (idList?: string[]) => void;

	originalKSK2022_R01DetailList: KSK2022_R01DetailDto[];
	setOriginalKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[]) => void;

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	KSK2022_R01InspectList: KSK2022_R01InspectDto[];
	setKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[]) => void;
	insertKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[], index?: number) => void;
	removeKSK2022_R01InspectList: (index: number) => void;
	updateKSK2022_R01InspectList: (index: number, data: KSK2022_R01InspectDto) => void;

	// ====== 선택(디테일) 불량 행 선택/삭제 관리 ======
	selectedKSK2022_R01InspectList: string[];
	setSelectedKSK2022_R01InspectList: (idList: string[]) => void;
	addSelectedKSK2022_R01InspectList: (idList: string[]) => void;
	removeSelectedKSK2022_R01InspectList: (idList?: string[]) => void;
	initSelectedKSK2022_R01InspectList: () => void;

	// ====== 생산실적 불량 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2022_R01InspectList: string[];
	setDeletedKSK2022_R01InspectList: (idList: string[]) => void;
	addDeletedKSK2022_R01InspectList: (idList: string[]) => void;
	removeDeletedKSK2022_R01InspectList: (idList?: string[]) => void;

	originalKSK2022_R01InspectList: KSK2022_R01InspectDto[];
	setOriginalKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	lotColumnState: ColumnState[] | null;
	setLotColumnState: (state: ColumnState[] | null) => void;
	
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	inspectColumnState: ColumnState[] | null;
	setInspectColumnState: (state: ColumnState[] | null) => void;

	allCount: number;					setAllCount: (allCount: number) => void;
	

	notProductResult: boolean;
	setNotProductResult: (notProductResult: boolean) => void;

	modalVisible: boolean;
	setModalVisible: (modalVisible: boolean) => void;
	workStandardModalVisible: boolean;
	setWorkStandardModalVisible: (visible: boolean) => void;
	workStandardSheetNo: 1 | 2 | null;
	setWorkStandardSheetNo: (sheetNo: 1 | 2 | null) => void;
	KSK2022_R01WorkStandard: KSK2022_R01WorkStandardDto | undefined;
	setKSK2022_R01WorkStandard: (workStandard: KSK2022_R01WorkStandardDto | undefined) => void;
	workTimeModalVisible: boolean;
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => void;
	workTimeModalType: 'start' | 'end' | null;
	setWorkTimeModalType: (type: 'start' | 'end' | null) => void;
	isDetailMaximized: boolean;
	setIsDetailMaximized: (value: boolean) => void;
	isResultLotMaximized: boolean;
	setIsResultLotMaximized: (value: boolean) => void;
	
	//화면의 초기 로드 플래그
	isInitialLoad: boolean;
	setIsInitialLoad: (isInitialLoad: boolean) => void;

	// ====== 초기화 ======
	initKSK2022_R01LotData: (shouldResetPendingLotQty?: boolean) => void;
	initData: () => void;

	// 창고 코드 필터링
	warehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	outWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	badWarehouseCdListToUseList: (logicCenter: string) => WareHouseDto[];
	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => void;

}

//각 Detail 행의 itemCd가 첫번째인지 검증하고. 첫번째라면 transportQty행에 bomUsingQty를 넣고, 아니라면 0을 넣는다.
export const takeDetailItemIsFirstIndex = (
	detailList: KSK2022_R01DetailDto[]
): number[] => {
	const firstValueIndices: number[] = [];
	const seenItemCds = new Set<string>();

	detailList.forEach((item) => {
		// childItemcd가 존재하고, 이전에 본 적 없는 값이라면
		if (item.childItemcd && !seenItemCds.has(item.childItemcd)) {
			// 방문 기록에 추가
			seenItemCds.add(item.childItemcd);
			// 결과 배열에 해당 행의 valueIndex 추가
			firstValueIndices.push(item.valueIndex);
		}
	});

	return firstValueIndices;
};

export const calculateLotQty = (lotList: KSK2022_R01LotDto[], deletedList: string[]): number => {
	return lotList.reduce((sum, item) => {
		if (deletedList.includes(item.valueIndex.toString())) {
			return sum;
		}
		return sum + (Number(item.lotQty) || 0);
	}, 0);
};

export const calculateBomUsingQty = (
	editKSK2022_R01: KSK2022_R01HeaderDto | null,
	detailItem: KSK2022_R01DetailDto,
): number => {
	if (!editKSK2022_R01) return detailItem.bomUsingQty;

	// ResultInfo 생산량(pendingLotQty)만 기준 — LOT 테이블 총량(productQty)과 분리
	const productQty = Number(editKSK2022_R01.pendingLotQty ?? 0);
	const fixLossqty = (productQty > 0) ? detailItem.fixLossqty || 0 : 0;

	return calculateTotalOrderQty(productQty, detailItem.childItemUsage, detailItem.lossPercent, fixLossqty);
};


export const recalculateDetailListWithTransport = (
	detailList: KSK2022_R01DetailDto[],
	editHeader: KSK2022_R01HeaderDto | null,
): KSK2022_R01DetailDto[] => {
	//각 itemCd에 해당하는 수량을 저장하는 곳
	const allocatedQtyMap = new Map<string, number>();

	return detailList.map(item => {
		// 동일한 childItemcd당 하나의 row만 transportQty가 bomUsingQty값과 같게 설정
		const bomUsingQty = calculateBomUsingQty(editHeader, item);
		
		//allocatedQtyMap에서 item.childItemcd의 키에 해당하는 수량을 가져오고, 없으면 0을 가져옴
		const currentAllocated = allocatedQtyMap.get(item.childItemcd) || 0;
		//bomUsingQty와 currentAllocated를 빼서 남은 수량을 계산
		const remainingNeeded = Math.max(0, bomUsingQty - currentAllocated);

		let transportQty = 0;
		if (remainingNeeded > 0) {
			transportQty = Math.min(remainingNeeded, item.lotQty);
		}

		//allocatedQtyMap에 item.childItemcd의 키에 해당하는 수량을 저장, 다음 row의 transportQty 계산에 활용
		allocatedQtyMap.set(item.childItemcd, currentAllocated + transportQty);

		// transportQty가 0보다 크면 무조건 저장 대상(isModified = true)으로 설정
		// 또는 값이 변경되었으면 true
		let isModified = transportQty > 0 || item.transportQty !== transportQty;

		if (transportQty === 0) {
			isModified = false;
		}

		return { ...item, bomUsingQty, transportQty, isModified };
	});
};


const calculateTotalProductQty = (editKSK2022_R01: KSK2022_R01HeaderDto, lotList: KSK2022_R01LotDto[], deletedList: string[]): number => {
	let productQtyFromLot = lotList.reduce((sum, item) => {
		if (deletedList.includes(item.valueIndex.toString())) {
			return sum;
		}
		return sum + (Number(item.lotQty) || 0);
	}, 0);

	// console.log('productQtyFromLot : ', productQtyFromLot);

	const productQty = productQtyFromLot;

	return productQty;
};

export const defaultKSK2022_R01Filter : KSK2022_R01Filter = {
	labelPrintAuto: 'N',
};


const getInitialKSK2022_R01HeaderDto = (): KSK2022_R01HeaderDto => {
	const { compCdList, workPlaceList, wmsCdList, warehouseCdList, itemStatusList } = useCommonCodeStore.getState();

	const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
    
    const warehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.productYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const outWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && (value.materialYn === 'Y' || value.manufactYn === 'Y' )
    ));
    const badWarehouseCdListToUse = warehouseCdList.filter(value => (value.logicCenter === defaultLogicCenter
        && value.badYn === 'Y'
    ));

	return {
		...defaultKSK2022_R01HeaderDto,
		compCd: compCdList?.[0]?.compCd || '',
		workplaceCd: workPlaceList?.[0]?.workplaceCd || '',
		logicCenter: defaultLogicCenter,
        warehouseCd: warehouseCdListToUse?.[0]?.warehouseCd || '',
        outWarehouseCd: outWarehouseCdListToUse?.[0]?.warehouseCd || '',
        badWarehouseCd: badWarehouseCdListToUse?.[0]?.warehouseCd || '',
        itemStatus: itemStatusList?.[0]?.minorCd || '',
		itemCd: '',
		itemNm: '',
	}
};


export const useKSK2022_R01Store = create<Store_KSK2022_R01>((set, get) => ({
	KSK2022_R01Filter: defaultKSK2022_R01Filter,
	KSK2022_R01PastFilter: defaultKSK2022_R01Filter,
	setKSK2022_R01Filter: (update) => set((state) => ({
		KSK2022_R01Filter: {
			...state.KSK2022_R01Filter,
			...update
		}
	})),
	setKSK2022_R01PastFilter: (filter: Store_KSK2022_R01['KSK2022_R01PastFilter']) => set((state) => {
		return {
			...state,
			KSK2022_R01PastFilter: filter
		}
	}),

	// ====== 생산실적 리스트 및 선택/편집 ======
	KSK2022_R01List: [],
	setKSK2022_R01List: (salesList: KSK2022_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			KSK2022_R01List: salesList
		}
	}),

	editKSK2022_R01: getInitialKSK2022_R01HeaderDto(),
	setEditKSK2022_R01: (editHeader: KSK2022_R01HeaderDto | null) => set((state) => {
		const pendingLotQtyChanged = editHeader != null
			&& state.editKSK2022_R01?.pendingLotQty !== editHeader.pendingLotQty;

		const newDetailList = pendingLotQtyChanged && editHeader != null
			? recalculateDetailListWithTransport(state.KSK2022_R01DetailList, editHeader)
			: state.KSK2022_R01DetailList;

		return {
			...state,
			editKSK2022_R01: editHeader,
			KSK2022_R01DetailList: newDetailList,
		}
	}),

	// selectedKSK2022_R01: undefined,
	
	// setSelectedKSK2022_R01: (data: KSK2022_R01HeaderDto | undefined) => set((state) => {
	// 	return { 
	// 		selectedKSK2022_R01: data, 
	// 		selectedKSK2022_R01LotList: [],  deletedKSK2022_R01LotList: [],
	// 		selectedKSK2022_R01DetailList: [], deletedKSK2022_R01DetailList: [],
	// 		selectedKSK2022_R01InspectList: [], deletedKSK2022_R01InspectList: [],
	// 	};
	// }),
	// initSelectedKSK2022_R01: () => {
	// 	set({
	// 		selectedKSK2022_R01: undefined,
	// 		editKSK2022_R01: getInitialKSK2022_R01HeaderDto(),
	// 		KSK2022_R01LotList: [] 
	// 	});
	// },

	// ====== 생산실적 상세(디테일) 데이터 ======
	KSK2022_R01LotList: [],
	setKSK2022_R01LotList: (data: KSK2022_R01LotDto[]) => set((state) => {
		let newList: KSK2022_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2022_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2022_R01LotList: newList,
		}
	}),
	insertKSK2022_R01LotList: (data: KSK2022_R01LotDto[], index?: number) => set((state) => {
		let newKSK2022_R01LotList = [...state.KSK2022_R01LotList];
		let maxValueIndex = Math.max(0, ...newKSK2022_R01LotList.map(item => item.valueIndex || 0)) + 1;

		// index가 없으면 맨 마지막에 추가
		if (index === undefined) {
			const maxOrderIndex = Math.max(0, ...newKSK2022_R01LotList.map(item => item.orderIndex || 0)) + 1;
			const newData = data.map(item => ({ ...defaultKSK2022_R01LotDto, ...item,
				valueIndex: maxValueIndex++,
				orderIndex: maxOrderIndex,
				orderIndexSeq: 1
			}));
			newKSK2022_R01LotList.push(...newData);

			return {
				...state,
				KSK2022_R01LotList: newKSK2022_R01LotList,
			}
		}

		let targetRowData = newKSK2022_R01LotList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2022_R01LotList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2022_R01LotList = newKSK2022_R01LotList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2022_R01LotList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2022_R01LotDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		newKSK2022_R01LotList.splice(index, 0, ...newData);

		return {
			...state,
			KSK2022_R01LotList: newKSK2022_R01LotList,
		}
	}),
	removeKSK2022_R01LotList: (index: number) => set((state) => {
		const newKSK2022_R01LotList = [...state.KSK2022_R01LotList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2022_R01LotList: newKSK2022_R01LotList,
		}
	}),
	updateKSK2022_R01LotList: (valueIndex: number, data: KSK2022_R01LotDto) => set((state) => {
		const _KSK2022_R01LotList = state.KSK2022_R01LotList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		if(data.lotQty < 0) {
			showWarning('수량은 0보다 작을 수 없습니다.');
			data.lotQty = 0;
		}
		return {
			...state,
			KSK2022_R01LotList: _KSK2022_R01LotList,
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2022_R01LotList: [],
	setDeletedKSK2022_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2022_R01LotList: idList
		}
	}),
	addDeletedKSK2022_R01LotList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedKSK2022_R01LotList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2022_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2022_R01LotList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		return {
			...state,
			deletedKSK2022_R01LotList: _deletedLotList,
		}
	}),
	removeDeletedKSK2022_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2022_R01LotList: [...state.deletedKSK2022_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2022_R01LotList: [],
	setSelectedKSK2022_R01LotList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedKSK2022_R01LotList: idList,
		}
	}),
	addSelectedKSK2022_R01LotList: (idList: string[]) => set((state) => {
		const _selectedKSK2022_R01LotList = [...state.selectedKSK2022_R01LotList];
		if(idList.length > 0) {
			_selectedKSK2022_R01LotList.push(...idList);
		}
		return {
			...state,
			selectedKSK2022_R01LotList: _selectedKSK2022_R01LotList
		}
	}),
	removeSelectedKSK2022_R01LotList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2022_R01LotList: [...state.selectedKSK2022_R01LotList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2022_R01LotList: () => set({ selectedKSK2022_R01LotList: [] }),	

	originalKSK2022_R01LotList: [],
	setOriginalKSK2022_R01LotList: (data: KSK2022_R01LotDto[]) => set((state) => {
		let newList: KSK2022_R01LotDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2022_R01LotDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2022_R01LotList: newList
		}
	}),

	// ====== 자재출고 상세(디테일) 데이터 ======
	KSK2022_R01DetailList: [],
	setKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[]) => set((state) => {
		let newList: KSK2022_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2022_R01DetailDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2022_R01DetailList: newList
		}
	}),
	insertKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[], index?: number) => set((state) => {
		let newKSK2022_R01DetailList = [...state.KSK2022_R01DetailList];

		let targetRowData = newKSK2022_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newKSK2022_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newKSK2022_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newKSK2022_R01DetailList = newKSK2022_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newKSK2022_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultKSK2022_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2022_R01DetailList.splice(index, 0, ...newData);
		} else {
			newKSK2022_R01DetailList.push(...newData);
		}

		return {
			...state,
			KSK2022_R01DetailList: newKSK2022_R01DetailList
		}
	}),
	removeKSK2022_R01DetailList: (index: number) => set((state) => {
		const newKSK2022_R01DetailList = [...state.KSK2022_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2022_R01DetailList: newKSK2022_R01DetailList
		}
	}),
	updateKSK2022_R01DetailList: (valueIndex: number, data: KSK2022_R01DetailDto) => set((state) => {
		const _KSK2022_R01DetailList = state.KSK2022_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? { ...data, isModified: true } : item
		);

		if(data.transportQty < 0) {
			showWarning('출고량은 0보다 작을 수 없습니다.');
			data.transportQty = 0;
		}
		return {
			...state,
			KSK2022_R01DetailList: _KSK2022_R01DetailList
		}
	}),
	
	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2022_R01DetailList: [],
	setDeletedKSK2022_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2022_R01DetailList: idList
		}
	}),
	addDeletedKSK2022_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedKSK2022_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2022_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2022_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK2022_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedKSK2022_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2022_R01DetailList: [...state.deletedKSK2022_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2022_R01DetailList: [],
	setSelectedKSK2022_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedKSK2022_R01DetailList: idList
		}
	}),
	addSelectedKSK2022_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedKSK2022_R01DetailList = [...state.selectedKSK2022_R01DetailList];
		if(idList.length > 0) {
			_selectedKSK2022_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedKSK2022_R01DetailList: _selectedKSK2022_R01DetailList
		}
	}),
	removeSelectedKSK2022_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2022_R01DetailList: [...state.selectedKSK2022_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2022_R01DetailList: () => set({ selectedKSK2022_R01DetailList: [] }),	

	originalKSK2022_R01DetailList: [],
	setOriginalKSK2022_R01DetailList: (data: KSK2022_R01DetailDto[]) => set((state) => {
		let newList: KSK2022_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2022_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2022_R01DetailList: newList
		}
	}),

	// ====== 생산실적 불량 상세(디테일) 데이터 ======
	KSK2022_R01InspectList: [],
	setKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[]) => set((state) => {
		let newList: KSK2022_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			// console.log(index + '번째 행의 item.Index 정보: ' 
			// 	+ ' valueIndex : ' + item.valueIndex 
			// 	+ ' valueAndOrderIndex : ' + valueAndOrderIndex
			// 	+ ' orderIndex : ' + item.orderIndex 
			// 	+ ' orderIndexSeq : ' + item.orderIndexSeq);
			newList.push({ 
				//...defaultKSK2022_R01InspectDto,
				...item,
				valueIndex: item.valueIndex > 0 ? item.valueIndex : valueAndOrderIndex,
				orderIndex: item.orderIndex > -1 ? item.orderIndex : valueAndOrderIndex,
				orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			KSK2022_R01InspectList: newList
		}
	}),
	insertKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[], index?: number) => set((state) => {
		const newKSK2022_R01InspectList = [...state.KSK2022_R01InspectList];

		//let valueIndex = newSYS4100_R01List.length + 1;
		let valueIndex = Math.max(0, ...newKSK2022_R01InspectList.map(item => item.valueIndex || 0)) + 1;
		let targetOrderIndex = index ? index : 1;
		// 같은 orderIndex를 가진 행들 중에서 가장 큰 orderIndexSeq 값을 찾는다.
		const maxOrderIndexSeq = Math.max(0, ...newKSK2022_R01InspectList
			.filter(item => item.orderIndex === targetOrderIndex)
			.map(item => item.orderIndexSeq || 0)
		);
		let targetOrderIndexSeq = maxOrderIndexSeq + 1;
		// console.log('newKSK2022_R01InspectList : ', newKSK2022_R01InspectList);
		// console.log('valueIndex : ', valueIndex 
		// 				+ ' 멤버 index : ' + index
		// 				+ ' 최종 orderIndex : ' + targetOrderIndex
		// 				+ ' 최종 orderIndexSeq : ' + targetOrderIndexSeq
		// 			);
		
		const newData = data.map(item => ({ ...defaultKSK2022_R01InspectDto, ...item, 
			valueIndex: valueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: targetOrderIndexSeq
		}));
		if (index !== undefined) {
			newKSK2022_R01InspectList.splice(index, 0, ...newData);
		} else {
			newKSK2022_R01InspectList.push(...newData);
		}
		return {
			...state,
			KSK2022_R01InspectList: newKSK2022_R01InspectList
		}
	}),
	removeKSK2022_R01InspectList: (index: number) => set((state) => {
		const newKSK2022_R01InspectList = [...state.KSK2022_R01InspectList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			KSK2022_R01InspectList: newKSK2022_R01InspectList
		}
	}),
	updateKSK2022_R01InspectList: (valueIndex: number, data: KSK2022_R01InspectDto) => set((state) => ({
		...state,
		KSK2022_R01InspectList: state.KSK2022_R01InspectList.map(item =>
			item.valueIndex === valueIndex ? data : item
		),
	})),

	// ====== 상세(디테일) 행 선택/삭제 관리 ======
	deletedKSK2022_R01InspectList: [],
	setDeletedKSK2022_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedKSK2022_R01InspectList: idList
		}
	}),
	addDeletedKSK2022_R01InspectList: (idList: string[]) => set((state) => {
		const _deletedLotList = [...state.deletedKSK2022_R01InspectList];

		for(const valueIndex of idList) {
			const isInserted = state.KSK2022_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.KSK2022_R01InspectList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedLotList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedKSK2022_R01InspectList: _deletedLotList
		}
	}),
	removeDeletedKSK2022_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		deletedKSK2022_R01InspectList: [...state.deletedKSK2022_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),

	selectedKSK2022_R01InspectList: [],
	setSelectedKSK2022_R01InspectList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedKSK2022_R01InspectList: idList
		}
	}),
	addSelectedKSK2022_R01InspectList: (idList: string[]) => set((state) => {
		const _selectedKSK2022_R01InspectList = [...state.selectedKSK2022_R01InspectList];
		if(idList.length > 0) {
			_selectedKSK2022_R01InspectList.push(...idList);
		}
		return {
			...state,
			selectedKSK2022_R01InspectList: _selectedKSK2022_R01InspectList
		}
	}),
	removeSelectedKSK2022_R01InspectList: (idList?: string[]) => set((state) => ({
		...state,
		selectedKSK2022_R01InspectList: [...state.selectedKSK2022_R01InspectList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedKSK2022_R01InspectList: () => set({ selectedKSK2022_R01InspectList: [] }),

	originalKSK2022_R01InspectList: [],
	setOriginalKSK2022_R01InspectList: (data: KSK2022_R01InspectDto[]) => set((state) => {
		let newList: KSK2022_R01InspectDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultKSK2022_R01InspectDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalKSK2022_R01InspectList: newList
		}
	}),

	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	lotColumnState: null,
	setLotColumnState: (state: ColumnState[] | null) => set({ lotColumnState: state }),

	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),

	inspectColumnState: null,
	setInspectColumnState: (state: ColumnState[] | null) => set({ inspectColumnState: state }),

	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
						

	notProductResult: true,
	setNotProductResult: (notProductResult: boolean) => set({ notProductResult }),

	modalVisible: false,
	setModalVisible: (modalVisible: boolean) => set({ modalVisible }),
	workStandardModalVisible: false,
	setWorkStandardModalVisible: (visible: boolean) => set({ workStandardModalVisible: visible }),
	workStandardSheetNo: null,
	setWorkStandardSheetNo: (sheetNo: 1 | 2 | null) => set({ workStandardSheetNo: sheetNo }),
	KSK2022_R01WorkStandard: undefined,
	setKSK2022_R01WorkStandard: (workStandard: KSK2022_R01WorkStandardDto | undefined) => set({ KSK2022_R01WorkStandard: workStandard }),

	workTimeModalVisible: false,
	setWorkTimeModalVisible: (workTimeModalVisible: boolean) => set({ workTimeModalVisible }),

	workTimeModalType: null,
	setWorkTimeModalType: (workTimeModalType: 'start' | 'end' | null) => set({ workTimeModalType }),

	isDetailMaximized: false,
	setIsDetailMaximized: (value: boolean) => set({ isDetailMaximized: value }),

	isResultLotMaximized: false,
	setIsResultLotMaximized: (value: boolean) => set({ isResultLotMaximized: value }),

	isInitialLoad: true,
	setIsInitialLoad: (isInitialLoad: boolean) => set({ isInitialLoad }),

	initKSK2022_R01LotData: (shouldResetPendingLotQty = true) => set((state) => {
		const nextEdit = state.editKSK2022_R01 ? {
			...state.editKSK2022_R01,
			pendingLotQty: shouldResetPendingLotQty
				? 0
				: state.editKSK2022_R01.pendingLotQty,
		} : state.editKSK2022_R01;

		return {
			KSK2022_R01LotList: [],
			deletedKSK2022_R01LotList: [],
			selectedKSK2022_R01LotList: [],
			originalKSK2022_R01LotList: [],
			editKSK2022_R01: nextEdit,
			KSK2022_R01DetailList: recalculateDetailListWithTransport(
				state.KSK2022_R01DetailList,
				nextEdit,
			),
		};
	}),

	// ====== 초기화 ======
	initData: () => set((state) => ({
		...state,
		KSK2022_R01Filter: defaultKSK2022_R01Filter,
		KSK2022_R01PastFilter: defaultKSK2022_R01Filter,
		KSK2022_R01List: [],
		selectedKSK2022_R01: undefined,
		editKSK2022_R01: getInitialKSK2022_R01HeaderDto(),

		KSK2022_R01LotList: [],
		deletedKSK2022_R01LotList: [],
		selectedKSK2022_R01LotList: [],
		originalKSK2022_R01LotList: [],

		KSK2022_R01DetailList: [],
		deletedKSK2022_R01DetailList: [],
		selectedKSK2022_R01DetailList: [],
		originalKSK2022_R01DetailList: [],

		KSK2022_R01InspectList: [],
		deletedKSK2022_R01InspectList: [],
		selectedKSK2022_R01InspectList: [],
		originalKSK2022_R01InspectList: [],

		allCount: 0,
		workStandardModalVisible: false,
		workStandardSheetNo: null,
		KSK2022_R01WorkStandard: undefined,
		
		isInitialLoad: true,
	})),

	warehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.goodsYn === 'Y' || value.productYn === 'Y')
		));
	},
	outWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& (value.manufactYn === 'Y')
		));
	},
	badWarehouseCdListToUseList: (logicCenter: string) => {
		const { warehouseCdList } = useCommonCodeStore.getState();
		return warehouseCdList.filter(value => (value.logicCenter === logicCenter
			&& value.badYn === 'Y'
		));
	},

	// 공통코드 로드 후 초기값 동기화
	syncInitialData: () => {
		const { compCdList, workPlaceList, wmsCdList, itemStatusList } = useCommonCodeStore.getState();
		const state = get();
		
		if (compCdList.length === 0) return;

		const defaultCompCd = compCdList?.[0]?.compCd || '';
		const defaultWorkplaceCd = workPlaceList?.[0]?.workplaceCd || '';
		const defaultLogicCenter = wmsCdList?.[0]?.minorCd || '';
		const defaultItemStatus = itemStatusList?.[0]?.minorCd || '';

		const warehouseCdListToUse = state.warehouseCdListToUseList(defaultLogicCenter);
		const outWarehouseCdListToUse = state.outWarehouseCdListToUseList(defaultLogicCenter);
		const badWarehouseCdListToUse = state.badWarehouseCdListToUseList(defaultLogicCenter);

		const defaultWarehouseCd = warehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultOutWarehouseCd = outWarehouseCdListToUse?.[0]?.warehouseCd || '';
		const defaultBadWarehouseCd = badWarehouseCdListToUse?.[0]?.warehouseCd || '';

		let newFilter = state.KSK2022_R01Filter;
		let newEditHeader = state.editKSK2022_R01;
		let needUpdate = false;

		if (state.editKSK2022_R01 && (!state.editKSK2022_R01.compCd || !state.editKSK2022_R01.logicCenter)) {
			newEditHeader = {
				...state.editKSK2022_R01,
				compCd: defaultCompCd,
				workplaceCd: defaultWorkplaceCd,
				logicCenter: defaultLogicCenter,
				warehouseCd: defaultWarehouseCd,
				outWarehouseCd: defaultOutWarehouseCd,
				badWarehouseCd: defaultBadWarehouseCd,
				itemStatus: defaultItemStatus,
			};
			needUpdate = true;
		}

		if (needUpdate) {
			set({
				editKSK2022_R01: newEditHeader
			});
		}
	},

	
}));
